import { __assign } from "tslib";
import React from 'react';
import { colors } from '../../theme';
import { styled } from '@mui/material';
import { Typography } from './Typography';
import { FlexColumn } from '../layout/FlexColumn';
var MyTextArea = styled('textarea')({
    backgroundColor: colors.white,
    fontFamily: 'IBM Plex Sans',
    fontSize: '14px',
    color: colors.gray[90],
    borderColor: colors.gray[20],
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '4px',
    padding: '12px 12px 12px 12px',
    minHeight: '40px',
    //paddingRight: multiline ? '4px' : 'default',
    '&:hover': {
        backgroundColor: colors.blue[5],
        borderColor: colors.gray[20],
        borderWidth: '1px'
    },
    '&:disabled': {
        borderColor: colors.gray[20],
        color: colors.gray[30]
    },
    '&:focus-visible': {
        borderColor: colors.blue[40] + ' !important',
        borderWidth: '1px !important',
        //border: 'inherited',
        boxShadow: 'none',
        outline: 'none'
    },
    overflowY: 'auto',
    '*::-webkit-scrollbar': {
        width: '4px'
    },
    '*::-webkit-scrollbar-track': {
        backgroundColor: colors.gray[10],
        borderRadius: '3px'
    },
    '*::-webkit-scrollbar-thumb': {
        backgroundColor: colors.gray[50],
        borderRadius: '3px'
    }
});
export var TextArea = function (_a) {
    var label = _a.label, name = _a.name, id = _a.id, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, cols = _a.cols, rows = _a.rows, width = _a.width, containerStyle = _a.containerStyle, textareaStyle = _a.textareaStyle;
    return (React.createElement(FlexColumn, { rowGap: '8px', style: __assign({ width: width, minWidth: '140px' }, containerStyle) },
        label ?
            React.createElement(Typography, { variant: 'body-regular' }, label)
            :
                null,
        React.createElement(MyTextArea, { name: name, id: id, cols: cols, rows: rows, onChange: onChange, disabled: disabled, placeholder: placeholder, readOnly: readOnly, required: required, style: __assign({ width: width, minWidth: '140px' }, textareaStyle) }, value)));
};
